if ($(".type-detail").length) {
  renderRecentlyViewed();

  $(".p-image-wrapper .p-image").append($(".product-top .flags.flags-default").clone());

  if ($(".benefitBanner.position--benefitProduct").length) {
    $(".row.product-top ").after($(".benefitBanner.position--benefitProduct").clone());
  }
  $(".availability-value").append($(".shipping-options").clone());

  function normalizeAvailabilityText(value) {
    return String(value || "")
      .replace(/\u00a0/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  function getDeliveryDateFromAvailability(availabilityText) {
    if (typeof getDeliveryDateByAvailability !== "function") {
      return null;
    }

    const normalized = normalizeAvailabilityText(availabilityText);
    let deliveryDate = getDeliveryDateByAvailability(normalized);

    if (deliveryDate) {
      return deliveryDate;
    }

    if (typeof deliveryMap === "object" && deliveryMap) {
      const matchedKey = Object.keys(deliveryMap).find((key) => normalizeAvailabilityText(key) === normalized);
      if (matchedKey) {
        deliveryDate = getDeliveryDateByAvailability(matchedKey);
      }
    }

    return deliveryDate || null;
  }

  function updateDetailDeliveryEstimate() {
    if (typeof getDeliveryDateByAvailability !== "function" || typeof formatDeliveryDate !== "function") {
      return;
    }

    $(".availability-value").each(function () {
      const $container = $(this);
      const $activeVariant = $container.find(".choose-variant").not(".noDisplay, .no-display").first();
      const $label = $activeVariant.length ? $activeVariant.find(".availability-label").first() : $container.find(".availability-label").first();

      if (!$label.length) {
        return;
      }

      $container.find(".deliveryEstimate").remove();

      const availabilityText = $label.text() || "";
      const normalizedAvailabilityText = normalizeAvailabilityText(availabilityText);
      const labelStyle = normalizedAvailabilityText === "skladem" ? "color: #1A9E4A" : $label.attr("style") || "";

      if (normalizedAvailabilityText === "skladem") {
        $label.attr("style", labelStyle);
      }

      const deliveryDate = getDeliveryDateFromAvailability(availabilityText);

      if (!deliveryDate) {
        return;
      }

      $label.after('<span class="deliveryEstimate" style="' + labelStyle + '">můžeme doručit do ' + formatDeliveryDate(deliveryDate) + "</span>");
    });
  }

  function refreshDetailUi() {
    handleVariants();
    updateDetailDeliveryEstimate();
  }

  function initThumbnailArrowsFix() {
    const rootSelector = ".p-thumbnails";

    function getCurrentLeft($inner) {
      const inlineLeft = parseFloat($inner[0].style.left);
      if (!Number.isNaN(inlineLeft)) {
        return inlineLeft;
      }

      const computedLeft = parseFloat($inner.css("left"));
      return Number.isNaN(computedLeft) ? 0 : computedLeft;
    }

    function getMetrics($root) {
      const $inner = $root.find(".p-thumbnails-inner").first();
      const $line = $inner.children("div").first();
      const $thumbs = $line.find("a.p-thumbnail");

      if (!$inner.length || !$line.length || !$thumbs.length) {
        return null;
      }

      const viewportWidth = $root.innerWidth();
      const firstLeft = $thumbs.first().position().left;
      const lastThumb = $thumbs.last();
      const lastLeft = lastThumb.position().left;
      const lastOuterWidth = lastThumb.outerWidth(true) || 0;
      const contentWidth = Math.max(0, Math.round(lastLeft - firstLeft + lastOuterWidth));
      const maxShift = Math.max(0, contentWidth - viewportWidth);

      return {
        $inner,
        $line,
        $thumbs,
        viewportWidth,
        maxShift,
      };
    }

    function getStepSize(metrics) {
      const { $thumbs } = metrics;

      if ($thumbs.length > 1) {
        const firstLeft = $thumbs.eq(0).position().left;
        const secondLeft = $thumbs.eq(1).position().left;
        const delta = Math.abs(secondLeft - firstLeft);

        if (delta > 0) {
          return delta;
        }
      }

      return $thumbs.eq(0).outerWidth(true) || 0;
    }

    function updateOverflowState($root) {
      const metrics = getMetrics($root);
      if (!metrics) {
        $root.find(".thumbnail-prev, .thumbnail-next").hide();
        return;
      }

      const { $inner, maxShift } = metrics;
      const currentShift = Math.max(0, -getCurrentLeft($inner));
      const hasPrev = currentShift > 1;
      const hasNext = currentShift < maxShift - 1;

      $root.toggleClass("overflow-prev", hasPrev);
      $root.toggleClass("overflow-next", hasNext);

      $root.find(".thumbnail-prev").toggle(hasPrev);
      $root.find(".thumbnail-next").toggle(hasNext);
    }

    function applyShiftFromBase($root, direction, baseShift) {
      const metrics = getMetrics($root);

      if (!metrics) {
        return;
      }

      const { $inner, maxShift } = metrics;
      const stepSize = getStepSize(metrics);
      const slidesPerClick = 3;

      if (!stepSize) {
        return;
      }

      const safeBaseShift = Math.max(0, Math.min(maxShift, baseShift));
      const clickStep = stepSize * slidesPerClick;
      let targetShift = direction === "next" ? safeBaseShift + clickStep : safeBaseShift - clickStep;

      targetShift = Math.max(0, Math.min(maxShift, targetShift));

      $inner.css("left", -targetShift + "px");
      $root.data("thumbnailFixShift", targetShift);
      updateOverflowState($root);
    }

    $(document)
      .off("click.thumbnailFix", rootSelector + " .thumbnail-next")
      .on("click.thumbnailFix", rootSelector + " .thumbnail-next", function (e) {
        const $root = $(this).closest(rootSelector);
        const metrics = getMetrics($root);
        if (!metrics) {
          return;
        }

        e.preventDefault();
        e.stopImmediatePropagation();

        const storedShift = Number($root.data("thumbnailFixShift"));
        const currentShift = Math.max(0, -getCurrentLeft(metrics.$inner));
        const baseShift = Number.isFinite(storedShift) ? storedShift : currentShift;

        applyShiftFromBase($root, "next", baseShift);
        return false;
      });

    $(document)
      .off("click.thumbnailFix", rootSelector + " .thumbnail-prev")
      .on("click.thumbnailFix", rootSelector + " .thumbnail-prev", function (e) {
        const $root = $(this).closest(rootSelector);
        const metrics = getMetrics($root);
        if (!metrics) {
          return;
        }

        e.preventDefault();
        e.stopImmediatePropagation();

        const storedShift = Number($root.data("thumbnailFixShift"));
        const currentShift = Math.max(0, -getCurrentLeft(metrics.$inner));
        const baseShift = Number.isFinite(storedShift) ? storedShift : currentShift;

        applyShiftFromBase($root, "prev", baseShift);
        return false;
      });

    $(window)
      .off("resize.thumbnailFix")
      .on("resize.thumbnailFix", function () {
        $(rootSelector).each(function () {
          const $root = $(this);
          const metrics = getMetrics($root);
          if (!metrics) {
            return;
          }

          const safeShift = Math.max(0, Math.min(metrics.maxShift, -getCurrentLeft(metrics.$inner)));
          metrics.$inner.css("left", -safeShift + "px");
          $root.data("thumbnailFixShift", safeShift);
          updateOverflowState($root);
        });
      });

    $(rootSelector).each(function () {
      const $root = $(this);
      const metrics = getMetrics($root);
      if (!metrics) {
        return;
      }

      const safeShift = Math.max(0, Math.min(metrics.maxShift, -getCurrentLeft(metrics.$inner)));
      metrics.$inner.css("left", -safeShift + "px");
      $root.data("thumbnailFixShift", safeShift);
      updateOverflowState($root);
    });

    setTimeout(function () {
      $(rootSelector).each(function () {
        updateOverflowState($(this));
      });
    }, 250);
  }

  $(document).ready(function () {
    refreshDetailUi();
    initThumbnailArrowsFix();
    setTimeout(refreshDetailUi, 250);
  });

  $(document).on("change", '#simple-variants input[name="priceId"]', function () {
    setTimeout(refreshDetailUi, 0);
  });

  $(document).on("click", "#simple-variants label.advanced-parameter", function () {
    setTimeout(refreshDetailUi, 0);
  });

  $(".p-info-wrapper").append($(".p-detail-inner-header").clone());
  if (!$(".p-info-wrapper .customCart").length) {
    $(".p-info-wrapper").append('<div class="customCart"></div>');
  }
  $(".p-info-wrapper .customCart").append($(".p-final-price-wrapper"));
  $(".p-info-wrapper .customCart").append($(".add-to-cart"));

  $(".btn.btn-lg.btn-conversion.add-to-cart-button").text("Do košíku");

  function toggleExclusiveAccordion($tab, $content, onOpen) {
    const shouldOpen = !$tab.hasClass("open");

    $("#tab-content .shp-tab.added, #ratingTab, #productsAlternative, #slozeni, .products-related-header, .products-related").removeClass("open");

    if (!shouldOpen) {
      return;
    }

    $tab.addClass("open");
    $content.addClass("open");

    if (typeof onOpen === "function") {
      onOpen();
    }
  }

  $(document).on("click", ".shp-tab-link", function (e) {
    e.preventDefault();
    var target = $(this).attr("href");
    var $target = $(target);

    if (!target || !$target.length) {
      return;
    }
    // 1) aktivní tab class reset
    $(".shp-tab-link").removeClass("active");
    $(this).addClass("active");

    // 2) content switch
    $(".tab-content").removeClass("active");
    $target.addClass("active");

    // 3) scroll (volitelné)
    $("html, body").animate(
      {
        scrollTop: $target.offset().top - 100,
      },
      200,
    );
  });

  if (!$(".p-info-wrapper .stars-wrapper").length) {
    $(".p-info-wrapper").append($(".product-top .stars-wrapper").clone());
  }

  if ($("#productsAlternative").length) {
    if ($("body:not(.mobile)").length) {
      $(".type-detail .p-detail").append($("#productsAlternative"));
    }
    $("a[href='#productsAlternative']").text("Podobné produkty");
    $("#productsAlternative").prepend('<h2 class="products-alternative-header">Podobné produkty</h2>');
    $(".shp-tabs-wrapper #tab-content").append('<li class="alternative shp-tab pp added"><button >Podobné produkty</button></li>');

    var initialized = false;
    var $slider = $("#productsAlternative");

    $("li.alternative.shp-tab.pp.added button").on("click", function () {
      toggleExclusiveAccordion($("li.alternative.shp-tab.pp.added"), $("#productsAlternative"));
    });
  }

  if ($("#ratingTab").length) {
    function formatRatingTabLabel() {
      const $ratingLinks = $('.shp-tab-link[href="#ratingTab"]');
      if (!$ratingLinks.length) {
        return "";
      }

      let ratingCount = "";

      $ratingLinks.each(function () {
        const $link = $(this);
        const rawLabel = ($link.text() || "").trim();
        const match = rawLabel.match(/^(.*?)(?:\s*\(([^)]+)\))\s*$/);

        if (!match) {
          return;
        }

        const labelText = (match[1] || "").trim();
        const countText = (match[2] || "").trim();

        if (!countText) {
          return;
        }

        ratingCount = countText;

        $link.empty();
        $link.append(document.createTextNode(labelText + " "));
        $link.append($("<span />", { class: "rating-count", text: countText }));
      });

      return ratingCount;
    }

    const ratingCount = formatRatingTabLabel();

    function renderVotesStars() {
      $("#ratingWrapper .votes .rate-list").each(function () {
        const $rateList = $(this);
        const $stars = $rateList.find(".rate-star.stars").first();
        const value = parseInt(($rateList.find(".rate-value").first().text() || "").trim(), 10);

        if (!$stars.length || Number.isNaN(value)) {
          return;
        }

        const safeValue = Math.max(0, Math.min(5, value));

        $stars.find(".star").remove();

        for (let i = 1; i <= 5; i++) {
          $stars.append('<span class="star ' + (i <= safeValue ? "star-on" : "star-off") + '"></span>');
        }
      });
    }

    renderVotesStars();

    function isMobile() {
      return window.matchMedia("(max-width: 991px)").matches;
    }

    function getMobileScrollParent() {
      return document.querySelector(".content-wrapper") || document.querySelector("#page") || document.scrollingElement;
    }

    $(document).on("click", ".show-ratings", function (e) {
      e.preventDefault();

      const target = document.getElementById("ratingTab");
      if (!target) return;
      target.classList.add("open");
      const offset = 50;
      $(".ratetab").addClass("open");
      renderVotesStars();
      if (isMobile()) {
        // MOBILE (Shoptet wrapper scroll)
        const scrollParent = getMobileScrollParent();

        const parentRect = scrollParent.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();

        const top = targetRect.top - parentRect.top + scrollParent.scrollTop - offset;

        $(scrollParent).stop().animate(
          {
            scrollTop: top,
          },
          400,
        );
      } else {
        // DESKTOP (window scroll)

        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

        $("html, body").stop().animate(
          {
            scrollTop: top,
          },
          400,
        );
      }
    });

    const $ratingMobileTab = $('<li class="ratetab shp-tab ed added"><button>Hodnocení</button></li>');
    if (ratingCount) {
      $ratingMobileTab.find("button").append(" ");
      $ratingMobileTab.find("button").append($("<span />", { class: "rating-count", text: ratingCount }));
    }

    $("#ratingTab").before($ratingMobileTab);
    $("li.ratetab.shp-tab.ed.added button").on("click", function (e) {
      toggleExclusiveAccordion($("li.ratetab.shp-tab.ed.added"), $("#ratingTab"), renderVotesStars);
    });
  }
  if ($(".products-related").length) {
    $(".products-related-header").attr("id", "products-related-header");
    $("#p-detail-tabs").append('<li class="shp-tab"><a href="#products-related-header">Související produkty</a></li>');

    $(".shp-tabs-wrapper #tab-content").append('<li class="related shp-tab rp added"><button >Související produkty</button></li>');

    var initialized = false;
    var $slider = $(".products-related");

    $("li.related.shp-tab.rp.added button").on("click", function () {
      toggleExclusiveAccordion($("li.related.shp-tab.rp.added"), $(".products-related-header, .products-related"), function () {
        $(".products-related-header").addClass("open");
        $(".products-related").addClass("open");

        if (!initialized) {
          $slider.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: false,
            autoplay: false,
            autoplaySpeed: 5000,
            dots: true,
            arrows: true,
            infinite: false,
            adaptiveHeight: false,
            responsive: [
              {
                breakpoint: 1200,
                settings: { slidesToShow: 3, slidesToScroll: 1 },
              },
              {
                breakpoint: 991,
                settings: { slidesToShow: 2, slidesToScroll: 1 },
              },
              {
                breakpoint: 550,
                settings: {
                  slidesToShow: 1,
                  variableWidth: true,
                },
              },
            ],
          });
          initialized = true;
        } else {
          setTimeout(() => {
            $slider.slick("setPosition");
          }, 50);
        }
      });
    });

    if (window.innerWidth >= 992) {
      if (!$slider.hasClass("slick-initialized")) {
        $slider.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          centerMode: false,
          autoplay: false,
          dots: true,
          arrows: true,
          infinite: false,
          adaptiveHeight: false,
          responsive: [
            {
              breakpoint: 1200,
              settings: { slidesToShow: 3, slidesToScroll: 1 },
            },
          ],
        });
      }
    }
  }

  if ($(".slozeni").length) {
    $(".description-inner").append($(".slozeni").clone().attr("id", "slozeni"));
    $("#slozeni").before('<li class="slozeni shp-tab ed added"><button >Složení & Péče</button></li>');
    $("#p-detail-tabs").append('<li class="shp-tab"><a href="#slozeni">Složení & Péče</a></li>');

    $("li.slozeni.shp-tab.ed.added button").on("click", function (e) {
      toggleExclusiveAccordion($("li.slozeni.shp-tab.ed.added"), $("#slozeni"));
    });
  }

  $('li[data-testid="tabDescription"] a').on("click", function (e) {
    $('li[data-testid="tabDescription"]').toggleClass("open");
    $(".basic-description").toggleClass("open");
    $(".extended-description").toggleClass("open");
  });

  $(".extended-description>h3:first").text("Technické parametry");
  $(".basic-description>h3:first").text("Popis produktu");

  const ratingText = $(".p-info-wrapper .stars-wrapper .sr-only").text();
  const ratingMatch = ratingText.match(/\d+,\d+/);
  if (ratingMatch && ratingMatch[0]) {
    $(".p-info-wrapper .stars-wrapper .sr-only").text(ratingMatch[0]);

    const ratingValue = parseFloat(ratingMatch[0].replace(",", "."));
    const decimalPart = ratingValue % 1;

    if (decimalPart > 0) {
      const $stars = $(".p-info-wrapper .stars-wrapper .stars.star-list .star");
      $stars.eq(Math.floor(ratingValue)).addClass("star-half");
    }
  }

}

function handleVariants() {
  const $wrap = $("#simple-variants");
  if (!$wrap.length) return;

  const $variants = $wrap.find("label.advanced-parameter");

  $variants.each(function () {
    const $label = $(this);
    const $inner = $label.find(".advanced-parameter-inner").first();
    const $input = $label.find('input[type="radio"][name="priceId"]').first();

    const rawTitle = ($inner.attr("data-original-title") || $inner.attr("title") || "").trim();
    const title = (rawTitle.includes(":") ? rawTitle.split(":").slice(1).join(":") : rawTitle).trim();

    $inner.removeAttr("data-original-title title").removeClass("show-tooltip");

    if (title) {
      const $title = $label.find(".variant-title");

      $title.length
        ? $title.text(title)
        : $label.append('<span class="variant-title">' + title + "</span>");
    }

    const unavailable = $input.attr("data-disable-button") === "1";
    const index = $input.attr("data-index");

    $label
      .toggleClass("is-available", !unavailable)
      .toggleClass("is-unavailable", unavailable);

    let availability = unavailable ? "Vyprodáno" : "Skladem";

    if (index) {
      const $availability = $(".availability-value .choose-variant." + index).first();
      const text = $availability.find(".availability-label").text().trim();
      const amount = $availability.find(".availability-amount").text().trim();

      if (text) availability = text;
      if (amount) availability += " " + amount;
    }

    const $availabilityText = $label.find(".variant-availability");

    $availabilityText.length
      ? $availabilityText.text(availability)
      : $label.append('<span class="variant-availability">' + availability + "</span>");
  });

  // Dostupné varianty první, vyprodané na konec
  $wrap.append(
    $variants.filter(".is-available"),
    $variants.filter(".is-unavailable")
  );

  const limit = $("body.mobile").length ? 6 : 12;
  const count = $variants.length;
  const $buttons = $wrap.nextAll(".show-more-variants");

  $buttons.slice(1).remove();

  if (count > limit) {
    const html =
      '<span class="show-more-variants btn btn-secondary">' +
        '<span class="text">+ dalších <b>' +
          (count - limit) +
          " variant</b>" +
        "</span>" +
      "</span>";

    $buttons.first().length
      ? $buttons.first().replaceWith(html)
      : $wrap.after(html);
  } else {
    $buttons.remove();
  }

  $(document)
    .off("click.handleVariantsOpen", ".show-more-variants")
    .on("click.handleVariantsOpen", ".show-more-variants", function () {
      $wrap.addClass("opened");
    });
}
